"use client"
import { MouseEventHandler, useMemo } from "react"
import { ClassNameValue, twMerge } from "tailwind-merge"

type TagProps = {
  tag: string
  highlight?: boolean
  destructive?: boolean
  onClick?: MouseEventHandler<HTMLButtonElement>
  className?: ClassNameValue
}

const Tag: React.FC<TagProps> = ({ tag, highlight, destructive = false, onClick, className }) => {
  const classHighligh = useMemo(() => "rounded bg-purple mr-1 mb-1 py-1 px-2 float-start text-white", [])
  const classNormal = useMemo(() => "rounded bg-gray-30 mr-1 mb-1 py-1 px-2 float-start", [])
  const classDelete = useMemo(() => "rounded bg-orange-600 mr-1 mb-1 py-1 px-2 float-start text-white", [])

  return (
    <>
      {!!onClick ? (
        <button
          className={twMerge(destructive ? classDelete : highlight ? classHighligh : classNormal, className)}
          onClick={(e) => onClick(e)}>
          {tag}
        </button>
      ) : (
        <span className={twMerge(highlight ? classHighligh : classNormal, className)}>{tag}</span>
      )}
    </>
  )
}

export default Tag
